import { useState, useEffect } from 'react';
import { supabase, Category } from '../lib/supabase';

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .schema('premios')
        .from('categories')
        .select('*')
        .order('name');

      if (error) throw error;
      setCategories(data || []);
    } catch (err) {
      setError(err as Error);
      console.error('Error loading categories:', err);
    } finally {
      setLoading(false);
    }
  };

  return { categories, loading, error, reload: loadCategories };
};
